module.exports = __webpack_public_path__ + "static/Flavor_18AMT90223-e1de4805ffc949cead02ec9badb5baf4.pdf";